const tab_sections = {
    identity: 'الهوية',
    integrations: 'الاتصالات',
    login_security: 'تسجيل الدخول والأمان',
    permissions: 'الأذونات',
    automation: 'الأتمتة',
    platform: 'المنصة',
    overview: 'نظرة عامة',
    authentication: 'المصادقة',
    authorization: 'الترخيص',
    users: 'المستخدمين',
    developer: 'المطور',
    tenant: 'المستأجر',
};
export default Object.freeze(tab_sections);
